export function orgHasMembersInChildren(children, memberCountMap) {
    var _a;
    if (children.length > 0) {
        for (const child of children) {
            const id = child.id.split('_')[0];
            if (((_a = memberCountMap.get(id)) !== null && _a !== void 0 ? _a : 0) > 0) {
                return true;
            }
            if (child.children.length > 0) {
                return orgHasMembersInChildren(child.children, memberCountMap);
            }
        }
    }
    return false;
}
